export default {
  verboseName: "Manifestazione",
  verboseNamePlural: "Manifestazioni",
  modelName: "Show",
  modelNamePlural: "Shows",
  appName: "shows",
  propName: "show",
  propNamePlural: "shows",
}
